export enum SupportedNetworksEnum {
    AMEX,
    DISCOVER,
    INTERAC,
    JCB,
    MASTERCARD,
    VISA
}
